module.exports = __webpack_public_path__ + "static/media/Letra_Caixa (17).e3d84bbc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Letra_Caixa/Letra_Caixa (17).jpg
// module id = 339
// module chunks = 0